import _request from '@/utils/request';

const request =({url,...config}) => _request({url:`${process.env.VUE_APP_BASE_API_KD9}${url}`,...config})

export function testApi() {
  return request({
    url:'/ecwechat/wechat/home-banner'
  })
}

export function getChamberMsgById(id) {
  return request({
    url:'/api/wechatAuth/agent/getAgentLogDetail',
    params: { id }
  })
}